import { render, staticRenderFns } from "./add_input.vue?vue&type=template&id=76ba488e&lang=pug&"
import script from "./add_input.vue?vue&type=script&lang=js&"
export * from "./add_input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76ba488e')) {
      api.createRecord('76ba488e', component.options)
    } else {
      api.reload('76ba488e', component.options)
    }
    module.hot.accept("./add_input.vue?vue&type=template&id=76ba488e&lang=pug&", function () {
      api.rerender('76ba488e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/payment/add_input.vue"
export default component.exports